<template>
  <div class="join-container">
    <div class="join-container_ cen">
      <Breadcrumb>
        <BreadcrumbItem to="/">首页</BreadcrumbItem>
        <BreadcrumbItem to="/join">加入我们</BreadcrumbItem>
        <BreadcrumbItem>{{currentClassName.classname}}</BreadcrumbItem>
      </Breadcrumb>
      <div class="inside-main">
        <div class="goldenyears-container">
          <div class="volunteer-detail-item">{{currentClassName.classname}}</div>
          <!--<div class="goldenyears-tip"><div>我们在金色年华有广泛的职位适合您</div></div>-->
          <div class="goldenyears-cont" v-html="detailInfo.content"></div>
          <div class="goldenyears-list">
            <div class="goldenyears-li" v-for="item in jobList" :key="item.id">
              <div class="goldenyears-li-head">
                <div class="goldenyears-li-item">招聘岗位：</div>
                <div class="goldenyears-li-title">{{item.title}}</div>
              </div>
              <div class="goldenyears-li-info">
                <div class="goldenyears-li-address"><span>工作地点：</span><span>{{item.jobplace}}</span></div>
                <div class="goldenyears-li-salary"><span>薪资：</span><span class="colr">{{item.treatment}}</span></div>
              </div>
              <div class="goldenyears-li-cont" v-html="item.content"></div>
            </div>
          </div>
        </div>
        <div class="inside-left-nav">
          <div class="left-nav-head">
            <div class="chname">{{fname.classname}}</div>
            <div class="enname">{{fname.classname_en}}</div>
          </div>
          <div class="left-nav-list">
            <div class="left-nav-li">
              <router-link to="/join/volunteer" class="left-nav-link">
                <div class="chname">{{getsort[0].classname}}</div>
                <div class="enname">{{getsort[0].classname_en}}</div>
                <span></span>
              </router-link>
            </div>
            <div class="left-nav-li active">
              <router-link to="/join/goldenyears" class="left-nav-link">
                <div class="chname">{{getsort[1].classname}}</div>
                <div class="enname">{{getsort[1].classname_en}}</div>
                <span></span>
              </router-link>
            </div>
            <div class="left-nav-li">
              <router-link to="/join/socialservice" class="left-nav-link">
                <div class="chname">{{getsort[2].classname}}</div>
                <div class="enname">{{getsort[2].classname_en}}</div>
                <span></span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getHeaderData, getJoinBasicData, getJoinDetailData, getJobListData } from '../../api/getData.js'
export default {
  name: 'goldenYears',
  data () {
    return {
      headerInfo: {},
      cid: 23,
      currentClassName: '',
      fname: {},
      getsort: [],
      detailInfo: [],
      jobList: []
    }
  },
  metaInfo () {
    return {
      title: this.headerInfo.title,
      meta: [
        { name: 'generator', content: this.headerInfo.generator },
        { name: 'author', content: this.headerInfo.author },
        { name: 'keywords', content: this.headerInfo.keywords },
        { name: 'description', content: this.headerInfo.description }
      ]
    }
  },
  created () {
    this.getJoinBasicInfo(this.cid)
    this.getJobListInfo()
  },
  methods: {
    async getHeaderInfo () {
      let postData = { cid: this.cid }
      let header = await getHeaderData(postData)
      this.headerInfo = header.header
      this.$store.dispatch('SetActiveMenu', { activeMenu: 'join', activeSendMenu: 'goldenyears' }).then(() => {}).catch(() => {})
    },
    async getJoinBasicInfo (cid) {
      let postData = {}
      postData.cid = cid
      let result = await getJoinBasicData(postData)
      this.cid = result.cid
      this.currentClassName = result.cname
      this.fname = result.fname
      this.getsort = result.join_us
      this.getHeaderInfo()
      this.getJoinInfo()
    },
    async getJoinInfo () {
      let postData = {}
      postData.cid = this.cid
      let result = await getJoinDetailData(postData)
      this.detailInfo = result.info
    },
    async getJobListInfo () {
      let result = await getJobListData()
      this.jobList = result.joblist
    }
  }
}
</script>

<style scoped lang="less">
  .join-container_{
    padding-bottom: 60px;
  }
  .goldenyears-container{
    width: 77.22%;
    padding: 0 0 78px 64px;
    background-color: #ffffff;
    box-shadow: 0px 0px 13px 0px rgba(37, 37, 37, 0.15);
    border-radius: 5px;
    .volunteer-detail-item{
      border-left: 4px solid #e76321;
      margin-top: 72px;
      padding-left: 20px;
      font-size: 36px;
      line-height: 36px;
      color: #ec6420;
      font-weight: bold;
    }
    /*.goldenyears-tip{
      position: relative;
      margin-top: 72px;
      border-bottom: 1px solid #4b7bbe;
      div{
        position: absolute;
        bottom: -15px;
        left: 50%;
        transform: translateX(-50%);
        padding: 0 48px;
        background-color: #ffffff;
        font-size: 30px;
        line-height: 30px;
        text-align: center;
        color: #333333;
        font-weight: bold;
      }
    }*/
    .goldenyears-cont{
      margin-top: 40px;
      font-size: 30px;
      line-height: 40px;
      text-align: justify;
      color: #333333;
    }
  }
  .goldenyears-list{
    margin-top: 90px;
    .goldenyears-li{
      margin-top: 96px;
      padding-bottom: 48px;
      .goldenyears-li-head{
        overflow: hidden;
        .goldenyears-li-item{
          float: left;
          border-left: 4px solid #e76321;
          padding-left: 25px;
          font-size: 36px;
          line-height: 36px;
          color: #ec6420;
          font-weight: bold;
        }
        .goldenyears-li-title{
          font-size: 24px;
          line-height: 42px;
          color: #4b7bbe;
          font-weight: bold;
        }
      }
      .goldenyears-li-info{
        margin-top: 6px;
        overflow: hidden;
        div{
          float: left;
          margin-right: 235px;
          font-size: 24px;
          line-height: 48px;
          color: #333333;
          .colr{
            color: #eb6420;
          }
        }
      }
      .goldenyears-li-cont{
        margin-top: 50px;
        padding-right: 76px;
        font-size: 24px;
        line-height: 48px;
        color: #333333;
      }
    }
  }
  @media screen and (max-width: 1200px){
    .goldenyears-container{
      width: 100%;
      margin-bottom: 20px;
      padding: 36px 15px 32px;
      border-radius: 3px;
      .volunteer-detail-item{
        border-left: 2px solid #e76321;
        margin-top: 0px;
        padding-left: 10px;
        font-size: 18px;
        line-height: 18px;
      }
      .goldenyears-cont{
        margin-top: 20px;
        font-size: 15px;
        line-height: 20px;
      }
    }
    .goldenyears-list{
      margin-top: 45px;
      .goldenyears-li{
        margin-top: 30px;
        padding-bottom: 24px;
        .goldenyears-li-head{
          .goldenyears-li-item{
            float: left;
            border-left: 2px solid #e76321;
            padding-left: 12px;
            font-size: 18px;
            line-height: 18px;
          }
          .goldenyears-li-title{
            font-size: 12px;
            line-height: 21px;
          }
        }
        .goldenyears-li-info{
          margin-top: 3px;
          div{
            float: none;
            margin-right: 117px;
            font-size: 12px;
            line-height: 24px;
          }
        }
        .goldenyears-li-cont{
          margin-top: 15px;
          padding-right: 0;
          font-size: 12px;
          line-height: 24px;
        }
      }
    }
  }
</style>
<style lang="less">
  .goldenyears-cont{
    img,iframe,video{
      max-width: 100%;
    }
  }
  .goldenyears-li-cont{
    img,iframe,video{
      max-width: 100%;
    }
  }
</style>
